import { Image, Media } from '@tribeplatform/gql-client/types'
import { Image as ImageComponent } from '@tribeplatform/react-components/common'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'

export const Logo = ({
  image,
  alt,
  size = 'sm',
}: {
  image: Media
  alt: string
  size?: 'sm' | '3xl'
}) => {
  let height
  let width
  image = image as Image

  if (!image?.urls?.small) {
    height = 32
    width = 265
  }

  if (image?.width && image.height) {
    height = 32
    width = Math.round((image.width * 32) / image.height)
  }

  if (size === '3xl') {
    return (
      <ImageComponent
        className="bg-surface inline-block object-contain h-32 w-96 logo-image"
        height={128}
        width={128 * 3}
        src={image?.urls?.small || '/images/placeholder-logo.png'}
        alt={alt}
      />
    )
  }

  if (!image?.urls?.small) {
    return (
      <div
        className="flex space-s-2 items-center logo-image"
        style={{ maxWidth: '300px' }}
      >
        <Avatar name={alt} rounded="md" />
        <div className="font-medium truncate">{alt}</div>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: '300px' }} className="max-h-8 block logo-image">
      <img
        className="object-contain h-8 max-h-full max-w-full"
        width={width}
        height={height}
        src={image?.urls?.small}
        alt={alt}
      />
    </div>
  )
}
